import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormDateRangeInput } from './FormField';
import { useFieldLayout } from './useFieldLayout';

type DateRangeFieldProps = Omit<
  ComponentProps<typeof FormDateRangeInput>,
  'label' | 'inputHeight' | 'inputBackground'
> &
  FieldLayoutOptions;

export const DateRangeField = ({ label, hideLabel, ...fieldProps }: DateRangeFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormDateRangeInput
      label={field.label}
      aria-label={field.ariaLabel}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
